import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-budget-grid',
  templateUrl: './budget-grid.component.html',
  styleUrls: ['./budget-grid.component.css']
})
export class BudgetGridComponent implements OnInit {

  title = "Budget List"; 
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/finance/budget/budget-grid/budget-grid.component.ts